import $ from 'jquery';
import toastr from 'toastr';

import { mountAllCriteria } from './allCriteria';
import { mountDiaryClassCriteria } from './allCriteria';
import { mountCategories } from './allCriteria';
import { mountAlerts } from './allCriteria';
import { mountWhatsappIntegrationForm } from './allCriteria';

$(document).ready(function() {
  var $saveConfigs = $('.btn-save-js');
  var $saveConfigsFixed = $('.btn-fixed-save-js');

  $saveConfigs.click(function() {
    saveConfigurations();
  });

  $saveConfigsFixed.click(function() {
    saveConfigurations();
  });
});

function saveConfigurations() {
  var $initFirstSemester = $('.init-st-semester-js');
  var $endFirstSemester = $('.end-st-semester-js');
  var $initSecondSemester = $('.init-nd-semester-js');
  var $endSecondSemester = $('.end-nd-semester-js');
  var secretaryId = $('.select-secretaries-config-js option:selected').val();
  var schoolYear = $('.select-year-config-js option:selected').val();

  if ($initFirstSemester.val() == "" || $endFirstSemester.val() == "" || $initSecondSemester.val() == "" || $endSecondSemester.val() == "") {
    toastr.warning(I18n.t('views.configs.school_year.warning.st_init_end_date_blank'));
    return;
  }

  var schoolCriteria = mountAllCriteria('.school-criteria-js');
  var projectCriteria = mountAllCriteria('.project-criteria-js');
  var occurrenceCriteria = mountDiaryClassCriteria();
  var occurrenceCategories = mountCategories();
  var alerts = mountAlerts();
  var wassenger = mountWhatsappIntegrationForm();

  var oneSchoolChecked = verifyCheckedValues('.school-criteria-js', 'criteriumStatus');
  var oneProjectChecked = verifyCheckedValues('.project-criteria-js', 'criteriumStatus');
  var oneCategoryChecked = verifyCheckedValues('.category-criteria-js', 'categoriesStatus');
  var oneDairyChecked = verifyDairyCriteriaChecked();

  if (!oneProjectChecked || !oneSchoolChecked || !oneCategoryChecked || !oneDairyChecked) return;

  if (schoolCriteria == "" || projectCriteria == "" || occurrenceCriteria == "" || occurrenceCategories == "") {
    toastr.warning(I18n.t('views.configs.criteria.errors.blank_criterium'));
    return;
  }

  if (schoolCriteria == "blank" || projectCriteria == "blank" || occurrenceCriteria == "blank" || occurrenceCategories == "blank") {
    toastr.warning(I18n.t('views.configs.criteria.errors.add_blank_criterium'));
    return;
  }

  $.ajax({
    method: 'PUT',
    url: './configs/update_configurations',
    dataType: 'json',
    data: {
      secretary_id: secretaryId,
      st_start_date: $initFirstSemester.val(),
      st_end_date: $endFirstSemester.val(),
      nd_start_date: $initSecondSemester.val(),
      nd_end_date: $endSecondSemester.val(),
      school_criteria: JSON.stringify(schoolCriteria),
      project_criteria: JSON.stringify(projectCriteria),
      occurrence_criteria: JSON.stringify(occurrenceCriteria),
      occurrence_categories: JSON.stringify(occurrenceCategories),
      alerts_configuration: JSON.stringify(alerts),
      wassenger_configuration: JSON.stringify(wassenger),
      school_year: schoolYear
    },
    success: function(data) {
      $('.criterium-field-js').prop('disabled', true);
      refreshValues();
      toastr.success(I18n.t('views.configs.school_year.success.saved'));
    },
    error: function(data) {
      toastr.error(data.responseJSON.message);
    }
  });
}

function refreshValues() {
  var partnerId = $('.select-partner-config-js option:selected').val();
  var secretaryId = $('.select-secretaries-config-js option:selected').val();
  var yearId = $('.select-year-config-js option:selected').val();

  findAllConfigurations(partnerId, secretaryId, yearId);
}

function verifyCheckedValues(input, type) {
  var cont = 0;
  var status = [];
  $(input + ' input[name^='+type+']').each(function(){
    if (this.value == 'inactive' || this.value == 'on') {
      cont += 1;
    }
    status.push(this.value);
  })

  if (cont == status.length) {
    toastr.warning(I18n.t('views.configs.criteria.errors.one_criterium_active'));
    return false;
  }

  return true;
}

function verifyDairyCriteriaChecked() {
  var categories = [];
  $('.class-diary-all-criteria input[name^=categoryId]').each(function() {
    categories.push($(this).val());
  });

  var inactiveFields = false;
  categories.forEach(function(object) {
    var criteria = []
    var cont = 0;

    if (object != "") {
      if ($('.socioemotional-'+object+'-criteria-js input[name^=criteriumStatus]').length > 0) {
        $('.socioemotional-'+object+'-criteria-js input[name^=criteriumStatus]').each(function() {
          if (this.value == 'inactive' || this.value == 'on') {
            cont += 1;
          }
          criteria.push(this.value);
        })

        if (cont == criteria.length) {
          inactiveFields = true;
          return false;
        }
      }

      if ($('.diary-'+object+'-criteria-js input[name^=criteriumStatus]').length > 0) {
        $('.diary-'+object+'-criteria-js input[name^=criteriumStatus]').each(function() {
          if (this.value == 'inactive' || this.value == 'on') {
            cont += 1;
          }
          criteria.push(this.value);
        })

        if (cont == criteria.length) {
          inactiveFields = true;
          return false;
        }
      }
    }

    if (inactiveFields) {
      return false;
    }
  });

  if (inactiveFields) {
    toastr.warning(I18n.t('views.configs.criteria.errors.one_criterium_active'));
    return false;
  }
  return true;
}
